export const DateToBeginApplication = "2021-11-30";
